import http from "@/http";
// ### 订单列表
// https://zs.xzu.ink/api/order/list
export const getOrderList = {
  p: "/api/order/list",
  r: data => {
    return http({
      url: "/api/order/list",
      method: "post",
      data
    });
  }
};
// ### 订单推送
// https://zs.xzu.ink/api/order/push
export const pushOrder = {
  p: "/api/order/push",
  r: data => {
    return http({
      url: "/api/order/push",
      method: "post",
      data
    });
  }
};
// ### 订单退单
// https://zs.xzu.ink/api/order/refund
export const refundOrder = {
  p: "/api/order/refund",
  r: data => {
    return http({
      url: "/api/order/refund",
      method: "post",
      data
    });
  }
};
// ### 获取订单详情
// https://zs.xzu.ink/api/order/details/41
export const getOrderInfo = {
  p: "/api/order/details",
  r: data => {
    return http({
      url: "/api/order/details/" + data.id,
      method: "get"
      // data
    });
  }
};
//### 发起退款
// https://zs.xzu.ink/member/api/order/refund
export const getOrderRefund = {
  p: "/member/api/order/refund",
  r: data => {
    return http({
      url: "/member/api/order/refund",
      method: "post",
      data
    });
  }
};
//### 退款订单列表
// https://zs.xzu.ink/api/order/refund_list
export const getOrderRefundList = {
  p: "/api/order/refund_list",
  r: data => {
    return http({
      url: "/api/order/refund_list",
      method: "post",
      data
    });
  }
};
//### 退款订单审核
// https://zs.xzu.ink/api/order/refund_edit
export const editOrderRefund = {
  p: "/api/order/refund_edit",
  r: data => {
    return http({
      url: "/api/order/refund_edit",
      method: "post",
      data
    });
  }
};
//### 提现审核列表
// https://zs.xzu.ink/api/rebate/list
export const getOrderRebate = {
  p: "api/withdraw/list",
  r: data => {
    return http({
      url: "api/withdraw/list",
      method: "post",
      data
    });
  }
};
//提现审核
export const editWithdraw = {
  p: "api/withdraw/edit",
  r: data => {
    return http({
      url: "api/withdraw/edit",
      method: "post",
      data
    });
  }
};
//编辑提现
export const upWithdraw = {
  p: "api/withdraw/update",
  r: data => {
    return http({
      url: "api/withdraw/update",
      method: "post",
      data
    });
  }
};
//重置提现
export const restWithdraw = {
  p: "api/withdraw/rest_sn",
  r: data => {
    return http({
      url: "api/withdraw/rest_sn",
      method: "post",
      data
    });
  }
};
//### ### 返利详情
// https://zs.xzu.ink/api/rebate/details/1
export const getRebateInfo = {
  p: "/api/rebate/details",
  r: data => {
    return http({
      url: "/api/rebate/details/" + data.id,
      method: "get"
      // data
    });
  }
};
//### 返利审核
// https://zs.xzu.ink/api/rebate/edit
export const editRebate = {
  p: "/api/rebate/edit",
  r: data => {
    return http({
      url: "/api/rebate/edit",
      method: "post",
      data
    });
  }
};
//### 补贴列表
// https://zs.xzu.ink/member/api/rebate/list
export const getMemberRebate = {
  p: "/api/rebate/list",
  // api/rebate/list
  r: data => {
    return http({
      url: "/api/rebate/list",
      method: "post",
      data
    });
  }
};
//### 提现详情
// https://zs.xzu.ink/member/api/rebate/details
export const getMemberRebateInfo = {
  p: "/member/api/rebate/details",
  r: data => {
    return http({
      url: "/member/api/rebate/details",
      method: "post",
      data
    });
  }
};
//### 导出
// export: {
//   p: 'post,/system/export/user',
//   r: (data) => http({ url: '/system/export/user', method: 'post', responseType: 'blob', data })
// }
// https://zs.xzu.ink/member/api/rebate/details
export const exportFile = {
  p: "/api/order/export",
  r: data => {
    return http({
      url: "/api/order/export",
      method: "post",
      responseType: "blob",
      data
    });
  }
};
// 佣金日志导出
export const exportRebateFile = {
  p: "/api/rebate/export",
  r: data => {
    return http({
      url: "/api/rebate/export",
      method: "post",
      responseType: "blob",
      data
    });
  }
};